import React, { useState, useRef } from "react";
import {
  AccountBalance,
  CreditCard,
  DoubleArrow,
  DynamicFeed,
  Edit,
  Delete,
} from "@mui/icons-material";
import { tooltipStyleProps } from "services/constants/Styles";
import { Tooltip, Drawer } from "@mui/material";
import { customAPI } from "services/utils/CustomAPI";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";
import { EditPayrollGroup } from "./EditPayrollGroup";
import { ConfirmationDialog } from "components/CustomComponents/ConfirmationDialog";
import * as Mui from "@mui/material";
import { tableRowSize } from "services/constants";
import { payrollGroupEmployeeHeader } from "pages/PayRoll/PayRollHeaders";
import MoveUpIcon from "@mui/icons-material/MoveUp";
import { useForm } from "react-hook-form";
import { useFetch } from "services/hooks/useFetch";
import {
  deleteText,
  deleteMessage,
  unSavedText,
  unSavedMessage,
  drawerStyle,
  themes,
  editIconStyle,
  deleteIconStyle,
  doubleArrowStyle,
  parentBoxStyle,
  childBoxStyleSpaceBetween,
} from "services/constants";

import {
  Box,
  Typography,
  IconButton,
  Paper,
  Card,
  Grid,
  Avatar,
  CardContent,
} from "@mui/material";
import { CustomAutoComplete } from "components/CustomComponents";
import { stickyHeader } from "services/constants";
import { infoStyle } from "services/constants";

export const ViewPayrollGroup = ({
  onClose,
  individualPayrollGrpData,
  reCallApi,
  setGetId,
  setHanldeLoader,
  screenAccess,
}) => {
  const requestCompanyId = useSelector((state) => state.tokenReducer.topbarCompanyId);
  const { domain } = useSelector((state) => state.tokenReducer);
  const [isEditPanelOpen, setIsEditPanelOpen] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [isDeactivateButton, setIsDeactivateButton] = useState(false);

  const containerRef = useRef(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const { result: getPayrollGrpData } = useFetch(
    `${domain}payroll/setup/payrollgroup/move-payroll-group-users?payroll_group_id=${individualPayrollGrpData?.id}&company_id=${requestCompanyId}`,
  );
  const {
    setValue,
    handleSubmit,
    register,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      payroll_group_name: "",
      effective_from: "",
      handle_move: false,
      user_id: "",
    },
  });

  const payrollGrpData = [
    {
      id: 1,
      label: "Pay Cycle",
      value: individualPayrollGrpData?.pay_run_cycle_name,
      icon: AccountBalance,
      variant: "blue",
    },
    {
      id: 2,
      label: "Payment Bank",
      value: individualPayrollGrpData?.source_bank_detail_name,
      icon: DynamicFeed,
      variant: "red",
    },

    {
      id: 3,
      label: "Payment Mode",
      value: individualPayrollGrpData?.mode_of_payment,
      icon: CreditCard,
      variant: "grey",
    },
  ];

  const hanldeEditPanel = () => {
    setIsEditPanelOpen(true);
  };

  const onSubmit = async (data) => {
    const response = await customAPI(
      `${domain}payroll/setup/payrollgroup/move-payroll-group-users?company_id=${requestCompanyId}`,
      "PUT",
      {
        payroll_group_id: data?.payroll_group_id,
        user_id: watch("user_id"),
      },
    );
    if (response.ok) {
      showToast("success", response?.responseDetails?.message);
      setGetId(individualPayrollGrpData?.id);
      setHanldeLoader(true);
      reCallApi(true);
      handleCancelClose();
    }
  };

  const handleClosePanel = () => {
    if (hasUnsavedChanges) {
      setShowConfirmationDialog(true);
    } else {
      setIsEditPanelOpen(false);
    }
  };

  const handleConfirmClose = () => {
    setShowConfirmationDialog(false);
    setIsEditPanelOpen(false);
  };

  const handleCancelClose = () => {
    setShowConfirmationDialog(false);
    setValue("handle_move", false);
    setIsDeactivateButton(false);
    reset();
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const hanldePayrollGrpName = (event, data) => {
    if (data) {
      setValue("payroll_group_name", data?.payroll_group_name);
      setValue("payroll_group_id", data?.payroll_group_id);
    } else {
      setValue("payroll_group_name", "");
      setValue("payroll_group_id", "");
    }
  };

  const deletePayRollGroup = async () => {
    setHanldeLoader(false);
    let payload = {
      isdeleted: true,
      company: individualPayrollGrpData?.company,
      mode_of_payment: individualPayrollGrpData?.mode_of_payment,
      name: individualPayrollGrpData?.name,
      payment_bank: individualPayrollGrpData?.source_bank_detail_name,
      payrun_cycle: individualPayrollGrpData?.pay_run_cycle_name,
      source_bank_detail: individualPayrollGrpData?.source_bank_detail,
    };
    const response = await customAPI(
      `${domain}payroll/setup/payrollgroup/payroll-group/${individualPayrollGrpData?.id}/`,
      "PUT",
      payload,
    );
    if (response.ok) {
      showToast("success", "Payroll group deleted.");
      reCallApi(true);
      onClose();
    } else {
      setValue("button_loader", false);
      showToast("error", response?.message);
    }
  };

  return (
    <>
      <Box sx={parentBoxStyle}>
        <ConfirmationDialog
          open={showConfirmationDialog}
          onClose={handleCancelClose}
          onConfirm={() => {
            if (isDeactivateButton) return deletePayRollGroup();
            if (watch("handle_move")) return handleSubmit(onSubmit)();
            return handleConfirmClose();
          }}
          title={
            showConfirmationDialog && isDeactivateButton
              ? deleteText
              : watch("handle_move")
                ? "Move Employee"
                : unSavedText
          }
          message={
            showConfirmationDialog && isDeactivateButton
              ? deleteMessage(individualPayrollGrpData?.pay_run_cycle_name)
              : unSavedMessage
          }
          confirmText={
            showConfirmationDialog && isDeactivateButton
              ? "Delete"
              : watch("handle_move")
                ? "Move"
                : "Exit"
          }
          showChildren={
            showConfirmationDialog ? Boolean(watch("handle_move")) : ""
          }
          cancelText={showConfirmationDialog ? "Cancel" : ""}
        >
          {watch("handle_move") && (
            <>
              <Box>
                <Typography sx={{ fontWeight: 600 }}>
                  New payroll group
                </Typography>
                <Typography {...infoStyle}>
                  Choose the payroll group to which the selected employees will
                  be reassigned
                </Typography>
                <CustomAutoComplete
                  dataList={getPayrollGrpData?.map((obj) => ({
                    ...obj,
                    label: obj?.payroll_group_name,
                  }))}
                  rules={{
                    ...register("payroll_group_name", {
                      required: "Payroll group is required",
                    }),
                  }}
                  selectedValue={watch("payroll_group_name")}
                  updateDataFunction={hanldePayrollGrpName}
                  placeHolder="Select a target payroll group (e.g., Monthly – 10th Day – A Group)"
                  errorMessage={
                    errors?.payroll_group_name?.message
                      ? errors?.payroll_group_name?.message
                      : ""
                  }
                  textBoxError={errors?.payroll_group_name ? true : false}
                />
              </Box>
            </>
          )}
        </ConfirmationDialog>

        <Paper elevation={0} sx={{ borderRadius: 0 }}>
          <Box>
            <Box sx={childBoxStyleSpaceBetween}>
              <IconButton onClick={onClose} sx={doubleArrowStyle}>
                <DoubleArrow />
              </IconButton>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Tooltip title="Delete" arrow slotProps={tooltipStyleProps}>
                  <IconButton
                    onClick={() => {
                      if (screenAccess) {
                        setShowConfirmationDialog(true);
                        setIsDeactivateButton(true);
                        setValue("handle_move", false);
                      } else {
                        showToast(
                          "error",
                          `Access denied: You are not authorized to inactivate payrun cycle `,
                        );
                      }
                    }}
                    sx={deleteIconStyle}
                  >
                    <Delete />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Edit" arrow slotProps={tooltipStyleProps}>
                  <IconButton
                    onClick={() => {
                      if (screenAccess) {
                        hanldeEditPanel();
                        setIsDeactivateButton(false);
                      } else {
                        showToast(
                          "error",
                          `Access denied: You are not authorized to edit payrun cycle`,
                        );
                      }
                    }}
                    sx={editIconStyle}
                  >
                    <Edit />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>

            <Box sx={{ ml: 2.2 }}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                {individualPayrollGrpData?.name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                View configuration and employee details for this payroll group.
              </Typography>
            </Box>
          </Box>
        </Paper>

        <Box sx={{ flexGrow: 1, overflow: "auto", p: 2 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 3,
              mt: 2,
              mb: 2,
            }}
          >
            <Grid container spacing={{ xs: 4, md: 6 }}>
              {payrollGrpData.map((item) => {
                const IconComponent = item.icon;
                const isBlue = item.variant === "blue";

                return (
                  <Grid item xs={12} sm={item.id === 1 ? 12 : 6} key={item.id}>
                    <Card
                      sx={{
                        bgcolor: "#3c73e70d",
                        borderRadius: "5px",
                        border: 0,
                        boxShadow: "0px 4px 4px #00000040",
                      }}
                    >
                      <CardContent sx={{ p: 2 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 2,
                            mb: 2,
                          }}
                        >
                          <Avatar
                            variant="rounded"
                            sx={{
                              width: 35,
                              height: 35,
                              bgcolor: isBlue ? "#3c73e71a" : "#bd09091a",
                              border: `0.5px solid ${item?.variant}`,
                              boxShadow: "0px 1px 2px #00000040",
                              color: item?.variant,
                            }}
                          >
                            <IconComponent
                              size={18}
                              color={isBlue ? "#3c73e7" : "#d71515"}
                            />
                          </Avatar>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 600,
                              mb: "auto",
                            }}
                          >
                            {item.label}
                          </Typography>
                        </Box>
                        <Box sx={{ pl: 1 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 700,
                              color: "#32325D",
                            }}
                          >
                            {item.value}
                          </Typography>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 600,
              }}
            >
              Employee List
            </Typography>
          </Box>
          <Box>
            <Mui.TableContainer ref={containerRef} sx={{ maxHeight: 450 }}>
              <Mui.Table className="border">
                <Mui.TableHead sx={stickyHeader}>
                  <Mui.TableRow sx={tableRowSize}>
                    {payrollGroupEmployeeHeader?.map((value) => (
                      <Mui.TableCell
                        sx={{
                          color: themes.headLine,
                          fontWeight: "bold",
                        }}
                      >
                        {value?.name}
                      </Mui.TableCell>
                    ))}
                  </Mui.TableRow>
                </Mui.TableHead>
                <Mui.TableBody>
                  {individualPayrollGrpData?.users_detail?.length === 0 ? (
                    <Mui.TableRow sx={{ padding: 2 }}>
                      <Mui.TableCell colSpan={3} sx={{ textAlign: "center" }}>
                        {
                          "No employees are currently assigned to this group. You can add employees during onboarding or move them here from another payroll group."
                        }
                      </Mui.TableCell>
                    </Mui.TableRow>
                  ) : (
                    individualPayrollGrpData?.users_detail
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage,
                      )
                      ?.map((value) => (
                        <Mui.TableRow
                          sx={{
                            ...tableRowSize,
                            "&:hover": { backgroundColor: "transparent" },
                          }}
                        >
                          {payrollGroupEmployeeHeader.map((head) => (
                            <Mui.TableCell>
                              {head?.name === "Action" ? (
                                <Tooltip
                                  title="Move"
                                  arrow
                                  slotProps={tooltipStyleProps}
                                >
                                  <IconButton
                                    sx={{ width: 23, height: 23 }}
                                    onClick={() => {
                                      if (screenAccess) {
                                        setShowConfirmationDialog(true);
                                        setValue("handle_move", true);
                                        setValue("user_id", value?.id);
                                      } else {
                                        showToast(
                                          "error",
                                          `Access denied: You are not authorized to edit payrun cycle`,
                                        );
                                      }
                                    }}
                                  >
                                    <MoveUpIcon
                                      sx={{
                                        color: "text.secondary",
                                        transition: "color 0.3s ease",
                                        "&:hover": {
                                          color: themes?.stepActiveColor,
                                          cursor: "pointer",
                                        },
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>
                              ) : head?.name === "Employee Name" ? (
                                <Mui.Stack
                                  direction="row"
                                  alignItems="center"
                                  spacing={1}
                                >
                                  <Mui.Avatar
                                    sx={{ width: 23, height: 23 }}
                                    alt={
                                      value?.username
                                        ?.charAt(0)
                                        ?.toUpperCase() || "U"
                                    }
                                    src={value?.image_url}
                                  />

                                  <Mui.Typography variant="body2">
                                    {value?.username || "N/A"}
                                  </Mui.Typography>
                                </Mui.Stack>
                              ) : (
                                (value[head.key] ?? "N/A")
                              )}
                            </Mui.TableCell>
                          ))}
                        </Mui.TableRow>
                      ))
                  )}
                </Mui.TableBody>
              </Mui.Table>
              {individualPayrollGrpData?.users_detail?.length > 5 && (
                <Mui.TablePagination
                  className="custom-pagination"
                  component="div"
                  rowsPerPageOptions={[25, 50, 75, 100]}
                  count={individualPayrollGrpData?.users_detail?.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              )}
            </Mui.TableContainer>
          </Box>
        </Box>
      </Box>
      <Drawer
        anchor="right"
        open={isEditPanelOpen}
        onClose={() => {
          handleClosePanel();
        }}
        sx={drawerStyle}
      >
        <EditPayrollGroup
          onClose={handleClosePanel}
          individualPayrollGrpData={individualPayrollGrpData}
          reCallApi={reCallApi}
          setGetId={setGetId}
          setIsEditPanelOpen={setIsEditPanelOpen}
          setHanldeLoader={setHanldeLoader}
          setHasUnsavedChanges={setHasUnsavedChanges}
        />
      </Drawer>
    </>
  );
};
